// import * as React from 'react';
// import CircularProgress from '@mui/material/CircularProgress';
// import Box from '@mui/material/Box';

// export default function Loader() {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '500px', 
//       }}
//     >
//       <CircularProgress />
//     </Box>
//   );
// }



import React from "react";
import Box from "@mui/material/Box";

const colors = ["#4285F4", "#EA4335", "#FBBC05", "#34A853"];

export default function GoogleDotsLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        gap: "8px",
      }}
    >
      {colors.map((color, i) => (
        <Box
          key={i}
          sx={{
            width: "14px",
            height: "14px",
            borderRadius: "50%",
            backgroundColor: color,
            animation: "bounce 1.2s infinite ease-in-out",
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
      <style>
        {`
          @keyframes bounce {
            0%, 80%, 100% {
              transform: scale(0);
            } 
            40% {
              transform: scale(1);
            }
          }
        `}
      </style>
    </Box>
  );
}
